const disabledInputsByProduct = {
    residualValue: {
        Crédito: true,
        ALD: false,
        "Crédito com Renda Balão": false,
        Leasing: false,
        "Crédito Motas": true,
        "Hyundai Open Drive": false,
        Financiación: true,
        "Finance FIT": false,
    },
    bailValue: {
        Crédito: true,
        ALD: false,
        "Crédito com Renda Balão": true,
        Leasing: true,
        "Crédito Motas": true,
        "Hyundai Open Drive": true,
        Financiación: true,
        "Finance FIT": true,
    },
    withDeposit: {
        Crédito: true,
        ALD: false,
        "Crédito com Renda Balão": true,
        Leasing: true,
        "Crédito Motas": true,
        "Hyundai Open Drive": true,
        Financiación: true,
        "Finance FIT": true,
    },
    withFinancedExpenses: {
        Crédito: false,
        ALD: true,
        "Crédito com Renda Balão": true,
        Leasing: true,
        "Crédito Motas": true,
        "Hyundai Open Drive": false,
        Financiación: false,
        "Finance FIT": false,
    },
    withFinancedTax: {
        Crédito: false,
        ALD: true,
        "Crédito com Renda Balão": true,
        Leasing: true,
        "Crédito Motas": true,
        "Hyundai Open Drive": false,
        Financiación: true,
        "Finance FIT": false,
    }
};

export { disabledInputsByProduct };
